/**
 * This agent's FACE — the surface it presents when it is the thing on screen.
 *
 * An agent has two representations and one implementation:
 *   - in-frame    — mounted by the main app in Home's detail pane
 *   - full-screen — mounted by this app at its own subdomain
 *
 * Both mount THIS component, so the two cannot drift. The module is how the
 * agent is packaged; the representation is only where it is mounted.
 *
 * The main app finds this file by CONVENTION, not from a registry: it globs
 * `apps/<slug>/src/face.tsx` and keys on the directory name.
 *
 * THIS AGENT IS NOT SESSION-SCOPED. The profile is the caller's own ("me"), so
 * every session of this agent opens the same profile and the board takes no
 * props at all. The face therefore accepts the standard props and ignores
 * them, which is also why this app's page can mount it with nothing: there is
 * no session for a session-less surface to pass.
 */
import { KnowledgeProfileConnected } from './components/knowledgeProfile/KnowledgeProfileConnected'
import type { AgentFaceProps } from '@frontend/components/agentDetail/agentFace'

export default function Face(_props: Partial<AgentFaceProps>) {
  return <KnowledgeProfileConnected />
}
